import SvgIcon from "@mui/material/SvgIcon";

import { CircleArrowProps } from "./CircleArrowUp";
import { circleArrowSvgIconStyles } from "./CircleSvgIcon.styles";

const CircleArrowDown = (props: CircleArrowProps): JSX.Element => {
  return (
    <SvgIcon
      sx={{
        ...circleArrowSvgIconStyles.sx,
        pointerEvents: props.disabled ? "none" : "auto",
        cursor: props.disabled ? "not-allowed" : "pointer",
        opacity: props.disabled ? 0.5 : 1,
      }}
      fill="none"
      {...props}
    >
      <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
      <path
        d="M15 10.5L12 13.5L9 10.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default CircleArrowDown;
